import { Button } from '@/components/ui/button'
import { FileText, Download } from 'lucide-react'
import { DocumentPreviewModal } from './DocumentPreviewModal'

type Template = {
  id: string
  name: string
  file_url: string | null
}

type Props = {
  title: string
  templates: Template[]
}

export function TemplateList({ title, templates }: Props) {
  if (templates.length === 0) return null

  return (
    <section className="border rounded-lg">
      <div className="px-4 py-3 border-b">
        <h2 className="text-sm font-medium text-foreground">{title}</h2>
      </div>
      <div className="px-4 py-3 space-y-2">
        {templates.map(t => (
          <div key={t.id} className="flex items-center justify-between">
            <div className="flex items-center gap-2 min-w-0">
              <FileText className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
              <span className="text-sm truncate">{t.name}</span>
            </div>
            {t.file_url && (
              <div className="flex items-center gap-1">
                <DocumentPreviewModal url={t.file_url} filename={t.name || 'Template'} />
                <a href={t.file_url} target="_blank" rel="noopener noreferrer">
                  <Button variant="ghost" size="icon" className="h-7 w-7" title="Download">
                    <Download className="w-3.5 h-3.5" />
                  </Button>
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
